/**
 * Corner radius scale, in dp/px — identical meaning on web (`border-radius`) and RN (`borderRadius`).
 * V2 leans into softer, more rounded geometry: inputs and buttons at `md`, cards at `lg`, dialogs
 * and hero surfaces at `xl`/`xxl`, and fully-rounded pills for chips, badges and avatars.
 */
export const radii = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 28,
  pill: 999,
} as const;

export type RadiusKey = keyof typeof radii;
